import { onMounted, onUnmounted } from 'vue'
import type { NotificationPayload, NotificationTopic } from '#src/interfaces/ngNotifications'

export const useNotificationEvent = <TTopic extends NotificationTopic>(
  topic: TTopic,
  callback: (detail: NotificationPayload<TTopic>) => void
) => {
  let listener: ((event: Event) => void) | undefined

  onMounted(() => {
    listener = (event: Event) => {
      callback((event as CustomEvent<NotificationPayload<TTopic>>).detail)
    }

    window.addEventListener(topic, listener)
  })

  onUnmounted(() => {
    if (listener) {
      window.removeEventListener(topic, listener)
    }
  })

  return {}
}
